import React, { Component, useEffect } from "react";
import AddEstimates from "views/Crm/addEstimate";
import AddEstimate from "views/Crm/addProposal";
function AddWorkOrder(props) {
  useEffect(() => {
  }, [])
  return <AddEstimates props={props} />
}
export default AddWorkOrder;
